import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { AuthService } from "../auth.service";

@Injectable()
export class RefreshTokenInterceptorService implements HttpInterceptor {
  private refreshTokenInProgress = false;
  // Refresh Token Subject hace el segumiento del refreshToken actual, o es null si no hay token
  // disponible (ejemplo refresh pendiente).
  private refreshTokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(
    null
  );
  constructor(public _auth: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        // No queremos refrescar el token en un request relacionado a login o a un refresco de token fallido
        if (
          request.url.includes("oauth")
        ) {
          // Si lo que falló fue un request de refreshToken, entonces hay que hacer logout
          if (request.body.includes("grant_type=refresh_token")) {
            this._auth.logout();
          }
          throw error;
        }
        // Si el error no fue 401, no queremos refrescar token
        if (error.status !== 401) {
          throw error;
        }

        if (this.refreshTokenInProgress) {
          throw error;
        } else {
          // Set refreshTokenSubject en null para que las siguientes llamadas a la API esperen hasta que se recupere el nuevo token
          this.refreshTokenSubject.next(null);
          this.refreshTokenInProgress = true;

          return this._auth.refreshToken().pipe(
            switchMap((refreshToken: string) => {
              // Cuando se completa la llamada a refreshToken, restablecemos el refreshTokenInProgress a false
              // para la próxima vez que sea necesario actualizar el token.
              this.refreshTokenInProgress = false;
              this.refreshTokenSubject.next(refreshToken);

              return next.handle(this.addAuthenticationToken(request));
            }),
            catchError((err) => {
              this.refreshTokenInProgress = false;
              this._auth.logout();
              throw error;
            })
          );
        }
      })
    );
  }

  addAuthenticationToken(request) {
    if (!request.url.includes("oauth") && this._auth.isLogged()) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${
            this._auth.user.getSessionData().accessToken
          }`,
          userToken: this._auth.user.getSessionData().userIdToken
        },
      });
    }
    return request;
  }
}
